import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import EditorMain from '../Editor/Editor.js'

import { IconBackSmall, IconDeviceDesktop2, IconDeviceMobile2 } from '../../svg'

class EditorTopbar extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            preview_mode: null,
        }
        this.base_state = this.state
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    componentDidMount() {
        this._isMounted = true

        this.setState({
            preview_mode: EditorMain.getPreviewMode,
        })

        EditorMain.subscribeEditorTopbar(this.onEditorRequest.bind(this))
    }

    async onEditorRequest({ method, data, callback }) {
        switch (method) {
            case 'react-project-load-start': {
                break
            }
            case 'react-project-load-end': {
                this.setState({
                    topbarmode: EditorMain.getProjectConfig().topbarmode || '',
                    hideDeviceSwitcher: EditorMain.getProjectConfig().hideDeviceSwitcher === true,
                })
                break
            }
            default:
                break
        }
    }

    changePreviewMode = mode => async evt => {
        evt.preventDefault()
        const success = EditorMain.changePreviewMode(mode)
        if (success) {
            this.setState({
                preview_mode: mode,
            })
        }
    }

    render() {
        const { name, step, status, events, is_published, project_loaded, t } = this.props
        const { preview_mode, hideDeviceSwitcher, topbarmode } = this.state

        return project_loaded ? (
            <div>
                <div className={`editor-topbar__mock ${topbarmode}`}></div>
                <div className={`editor-topbar ${topbarmode}`}>
                    <div className="editor-topbar__col editor-topbar__col--1">
                        <button
                            className="button"
                            data-size="md"
                            data-variant="black-white"
                            data-icon="back"
                            onClick={events.init_action('save-exit')}
                        >
                            <IconBackSmall />
                            {t('_components._editor._topbar.save_and_exit')}
                        </button>
                        <div className="name-box">
                            <span className="status-dot" data-status={status.value} title={status.label}></span>
                            <input
                                type="text"
                                value={name}
                                disabled={status.value !== 0}
                                onChange={evt => events.change_name(evt.target.value)}
                            />
                            <div className="notify">{status.value !== 0 ? status.label : null}</div>
                        </div>
                    </div>
                    <div className="editor-topbar__col editor-topbar__col--2">
                        <ul>
                            <li className={step === 0 ? 'is-active' : ''}>
                                <span onClick={events.change_step(0)}>
                                    {t('_components._editor._topbar._nav.editor')}
                                </span>
                                <div className="icon-arrow"></div>
                            </li>
                            <li className={step === 1 ? 'is-active' : ''}>
                                <span onClick={events.change_step(1)}>
                                    {t('_components._editor._topbar._nav.preview')}
                                </span>
                                <div className="icon-arrow"></div>
                            </li>
                            <li className={step === 2 ? 'is-active' : ''}>
                                <span onClick={events.change_step(2)}>
                                    {t('_components._editor._topbar._nav.integrations')}
                                </span>
                                <div className="icon-arrow"></div>
                            </li>
                            <li className={step === 3 ? 'is-active' : ''}>
                                <span onClick={events.change_step(3)}>
                                    {t('_components._editor._topbar._nav.review')}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div className="editor-topbar__col editor-topbar__col--3">
                        {step === 0 && hideDeviceSwitcher !== true ? (
                            <ul id="editor-tip__device-changer" className="topbar-device-changer">
                                <li
                                    className={`desktop${preview_mode === 'desktop' ? ' is-active' : ''}`}
                                    onClick={this.changePreviewMode('desktop')}
                                >
                                    <IconDeviceDesktop2 />
                                </li>
                                <li
                                    className={`mobile${preview_mode === 'mobile' ? ' is-active' : ''}`}
                                    onClick={this.changePreviewMode('mobile')}
                                >
                                    <IconDeviceMobile2 />
                                </li>
                            </ul>
                        ) : null}

                        {step !== 3 ? (
                            <button
                                className="button"
                                data-size="md"
                                data-variant="primary"
                                onClick={events.init_action('next')}
                            >
                                {t('_common.next')}
                            </button>
                        ) : null}
                        <button
                            className="button"
                            data-size="md"
                            data-variant={`${step !== 3 ? 'black-white' : 'primary'}`}
                            onClick={events.init_action('publish')}
                        >
                            {is_published
                                ? t('_components._editor._topbar.publish_changes')
                                : t('_components._editor._topbar.publish')}
                        </button>
                    </div>
                </div>
            </div>
        ) : null
    }
}

export default compose(connect(null, null), withTranslation('translations'))(EditorTopbar)
